import React from 'react'
import { useTranslation } from 'react-i18next'
import useZwykleCeny from '../../hooks/useZwykleCeny'
import { pln } from './format'
import { KRAJ } from '../../kraj'

/** Data cen „2026-10-24” jako „24.10.2026”. */
const dzien = (iso) => {
  const [r, m, d] = (iso || '').split('-')
  return r && m && d ? `${d}.${m}.${r}` : null
}

/**
 * „Zwykle taka instalacja kosztuje od X do Y” z estymatora zwykłych cen (`api/zwykleCeny`). Przy `kto_kupuje=klient`
 * widełki dotyczą samego montażu, bo zestaw klient kupuje osobno. Bez danych (endpoint jeszcze nie istnieje, błąd,
 * brak widełek) nic nie rysuje: to dodatek do wyniku, a nie jego warunek.
 */
const ZwykleCeny = ({ parametry, className = '' }) => {
  const { t } = useTranslation('asystent')
  const { dane } = useZwykleCeny(parametry)
  if (!dane) return null
  const montaz = parametry?.kto_kupuje === 'klient'
  const zrodlo = [dane.zrodlo, dane.data_cen ? t('prosty.zwykle_ceny.data', { data: dzien(dane.data_cen) }) : null]
    .filter(Boolean).join(', ')
  return (
    <div className={className} data-testid="zwykle-ceny">
      <p className="text-sm text-gray-700 leading-6">
        {t(montaz ? 'prosty.zwykle_ceny.montaz' : 'prosty.zwykle_ceny.calosc', { od: pln(dane.od), do: pln(dane.do) })}
        {montaz && dane.zestaw_cena ? ` ${t('prosty.zwykle_ceny.zestaw', { kwota: pln(dane.zestaw_cena) })}` : ''}
      </p>
      {zrodlo && (
        <p className="text-xs text-gray-500 leading-5">{t('prosty.zwykle_ceny.zrodlo', { zrodlo, waluta: KRAJ.symbol })}</p>
      )}
    </div>
  )
}

export default ZwykleCeny
